import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  CreateProspectDIRFormSchema,
  CreateProspectDIRMutation,
} from './CreateProspectDIRForm.types';
import { useMutation, useQueryClient } from 'react-query';
import { createProspectStepData } from './CreateProspectDIRForm.data';
import { getCreateProspectSchema } from './CreateProspectDIRForm.schema';
import { CREATE_PROSPECT_DIR_QUERY_KEY, createProspectDIRQuery } from './CreateProspectDIRForm.query';
import { useNavigate } from 'react-router-dom';
import Form from '../../../../../../commons/Form/Form';
import { DashboardProspectsDIRContext } from '../../DashboardProspectsDIR.context';
import { useContext, useMemo } from 'react';

export default () => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { commerciaux } = useContext(DashboardProspectsDIRContext);

  const formProps = useForm<CreateProspectDIRFormSchema>({
    resolver: yupResolver(getCreateProspectSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<
    Awaited<ReturnType<CreateProspectDIRMutation>>,
    Error,
    CreateProspectDIRFormSchema
  >((data) => createProspectDIRQuery({ ...data, commercialId: parseInt(data.commercialId) }), {
    mutationKey: CREATE_PROSPECT_DIR_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0);
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  const updatedFormData = useMemo(
    () =>
    createProspectStepData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'commercialId':
              return {
                ...item,
                options: commerciaux?.map(({ id, firstName, lastName }) => ({
                  label: `${firstName} ${lastName}`,
                  value: id.toString(),
                })),
              };
            default:
              return item;
          }
        })
      ),
    [commerciaux]
  );

  return (
    <>
      <Form<CreateProspectDIRFormSchema>
        data={updatedFormData}
        {...{ formProps, onSubmit }}
      />
    </>
  );
};
